module.exports = __webpack_public_path__ + "images/banner1.350e.png";